import React, { useContext, useEffect } from 'react';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';
import { IframeUrl } from '@home/components/IframeUrl';

const Web = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);
  const url = currentMenu?.url || '';
  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '801001',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/web/report/${nameEn || ''}`,
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);

  return (<IframeUrl url={url} />);
};

export default Web;